/** The single badge shown at the foot of a checkout surface. Never two at once. */
export const BADGE = {
  CHECKOUT_PAGE: 'checkoutpage',
  STRIPE: 'stripe',
  NONE: 'none',
};

// Only `free` forces our branding on here, but trialing sellers are branded in
// practice too: the API refuses to save `showCheckoutPageBranding: false` for
// non-paying sellers (SellerController) and the dashboard locks both toggles, so
// their flag stays true. `canceled` / `trial_expired` are never force-branded.
const BRANDING_FORCED_STATUSES = ['free'];

/**
 * Resolve which badge a checkout surface should show, applying the plan-based
 * override on top of the stored theme + seller settings.
 *
 * - Forced states (free): our branding on, Stripe off. Stored values ignored.
 * - Everyone else: a per-page theme override (`elements.poweredByCheckoutPage.enabled`)
 *   wins, else the seller-level global default (`showCheckoutPageBranding`). Our
 *   branding takes precedence over Stripe, so the two are mutually exclusive even if
 *   both happen to be enabled.
 *
 * @param {object} seller  Seller carrying `subscriptionStatus` + `showCheckoutPageBranding`.
 * @param {object} [theme] Page theme; reads `elements.poweredByCheckoutPage/poweredByStripe`.
 * @returns {'checkoutpage' | 'stripe' | 'none'}
 */
export default function resolveBadge(seller, theme) {
  if (!seller) return BADGE.NONE;

  if (BRANDING_FORCED_STATUSES.includes(seller.subscriptionStatus)) {
    return BADGE.CHECKOUT_PAGE;
  }

  const perPage = theme?.elements?.poweredByCheckoutPage?.enabled;
  const ourBrandingOn = perPage ?? seller.showCheckoutPageBranding === true;
  if (ourBrandingOn) return BADGE.CHECKOUT_PAGE;

  const stripeOn = theme?.elements?.poweredByStripe?.enabled !== false;
  if (stripeOn) return BADGE.STRIPE;

  return BADGE.NONE;
}
